export const ACCUMS_TEXTS = {
  sharingText: {
    master: 'делюсь тарифом',
    slave: 'общий тариф',
  },
  modal: {
    title: 'общий тариф\nс',
    text: 'другой номер делится с вами своим тарифом — гб, минуты и смс для вас бесплатные. вы платите только за роуминг, подключенные услуги и подписки',
    btnText: 'назад',
  },
  manage: {
    btnTitle: 'настроить тариф',
  },
  error: 'нажмите, чтобы обновить',
};

export const UNIT_LOCALE = {
  KBYTE: 'КБ',
  MEGABYTE: 'МБ',
  GIGABYTE: 'ГБ',
  TERABYTE: 'ТБ',
  SECONDS: 'секунд',
  MINUTES: 'минут',
  SMS: 'SMS',
  MMS: 'MMS',
} as const;

export const PRICE_PLAN_SOC_TYPE = 'PricePlan';

export const MAX_UNITS_LENGTH = {
  KBYTE: 1024,
  MEGABYTE: 1024 ** 2,
  GIGABYTE: 1024 ** 3,
  TERABYTE: 1024 ** 4,
  SECONDS: 60,
} as const;

export const FUB_COMMON_STATUS = {
  AVAILABLE: 'available',
  MASTER: 'master',
  SLAVE: 'slave',
  DENY: 'deny',
};

export const TITLE_TETHERING = 'ACC_TETHERING';

export const UNLIM_24_DEEP_LINK =
  '/customers/products/mobile/services/details/bezlimit-na-24-chasa/';

export const TETHERING_LINk = '/customers/products/mobile/services/details/sharepro/';
export const UNLIM_3_DEEP_LINk = 'https://dl.beeline.ru/unlim3h';
export enum UnlimThreeStatus {
  AVAILABLE = 'available',
  COOLING = 'cooling',
  ACTIVE = 'active',
}

export const UNLIM_MODAL = {
  IMAGE: 'https://static.beeline.ru/upload/images/b2c/footer/appLinkIcon.png',
  TITLE: 'подключай безлимит\n в приложении',
  QR_CODE: 'https://static.beeline.ru/upload/images/qr-unlim3h.svg',
  SUBTITLE: 'можно только там — сканируй',
  TEXT: '',
};
